//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { mdiTrashCanOutline } from '@mdi/js'
import { ref, onMounted } from '@vue/composition-api'
import themeConfig from '@themeConfig'
import { openTab } from '@core/utils'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@core/utils/useCryptoJs'

export default {
  setup() {
    const { t } = useUtils()
    const { decrypt } = useCryptoJs()

    const loginData = ref({})

    onMounted(async () => {
      const encryptLogData = await localStorage.getItem('logData')
      if (encryptLogData) {
        const decryptLogData = decrypt(JSON.parse(encryptLogData))
        loginData.value = {
          ...loginData.value,
          ...JSON.parse(decryptLogData),
        }
      }
    })

    return {
      loginData,

      openTab,

      // themeConfig
      appLogo: themeConfig.app.logo,
      appLogoTitle: themeConfig.app.logoTitle,
      t,

      icons: {
        mdiTrashCanOutline,
      },
    }
  },
}
